module.exports = __webpack_public_path__ + "img/games-8.6914ad5e.webp";